import { render, staticRenderFns } from "./index.vue?vue&type=template&id=81fb7f7e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=81fb7f7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81fb7f7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81fb7f7e')) {
      api.createRecord('81fb7f7e', component.options)
    } else {
      api.reload('81fb7f7e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=81fb7f7e&scoped=true&", function () {
      api.rerender('81fb7f7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/auto-creation-calc-sheets/components/tables-settings-table/index.vue"
export default component.exports